import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

export const useToast = () => {
  const showToast = (
    message: { text: string; list?: { text: string }[] },
    type: 'default' | 'error' = 'default',
    duration: number = 5000,
  ) => {
    const listItems = message.list?.map((item) => `<li>${item.text}</li>`).join('') || ''

    const toastNode = document.createElement('div')
    toastNode.innerHTML = `
      <div>
        <span style="font-size: 18px;">${message.text}</span>
        ${
          listItems
            ? `<ul style="font-size: 14px; margin-top: 4px; list-style-type: disc; padding-left: 18px;">${listItems}</ul>`
            : ''
        }
      </div>
    `

    Toastify({
      node: toastNode,
      gravity: 'bottom',
      position: 'left',
      duration,
      style: {
        background: type === 'default' ? '#212531' : '#b91c1c',
        boxShadow: 'none',
        borderRadius: '8px',
      },
    }).showToast()
  }

  return { showToast }
}
